<template>
  <div class="layout__padding-clear text__align-left">
    <div class="">
      <div class="layout__height-100 layout__position-center">
        <div class="">
          <div class="component__forms-3">
            <div class="component__subtitle text__colour-teal">
              Artwork Preview
            </div>
            <img
              class="layout__width-200px layout__padding-20-0"
              :src="instantPrintJob.imageUrlThumb[0].thumbnailURL"
            >
          </div>
          <div class="component__forms-2">
            <div class="layout__padding-clear">
              <!--{{this.instantPrintJob.printJobSpec}}-->
              <div class="component__subtitle text__colour-teal layout__padding__bottom-20">Print Selections</div>
              <div class="text__line-height-2 layout__padding-clear layout__width-100">
                <p class="component__subtitle component__columns-2">Product</p>
                <p
                  class="component__columns-2"
                  v-if="instantPrintJob.printJobSpec.name"
                >
                  {{ instantPrintJob.printJobSpec.name }}
                </p>
                <p v-else>-</p>
              </div>
              <div class="text__line-height-2 layout__padding-clear layout__width-100">
                <p class="component__subtitle component__columns-2">Paper Type</p>
                <p
                  class="component__columns-2"
                  v-if="instantPrintJob.printJobSpec.stockType"
                >
                  {{ instantPrintJob.printJobSpec.stockType }}
                </p>
                <p v-else>-</p>
              </div>
              <!--</div>-->
              <!--<div class="component__forms-5">-->
              <div class="text__line-height-2 layout__padding-clear layout__width-100">
                <p class="component__columns-2">Paper Weight</p>
                <p
                  class="component__columns-2"
                  v-if="instantPrintJob.printJobSpec.stockWeight"
                >
                  <span v-if="instantPrintJob.printJobSpec.stockWeight === 'DUR'">DURATRAN</span>
                  <span v-if="instantPrintJob.printJobSpec.stockWeight === 'INTRAN'">INTRAN</span>
                  <span v-if="instantPrintJob.printJobSpec.stockWeight === 'TRU'">TRUCARD</span>
                  <span
                    v-if="instantPrintJob.printJobSpec.stockWeight !== 'INTRAN' && instantPrintJob.printJobSpec.stockWeight !== 'DUR' && instantPrintJob.printJobSpec.stockWeight !== 'TRU'"
                  >
                    {{ instantPrintJob.printJobSpec.stockWeight }}
                  </span>
                  <span
                    v-if="instantPrintJob.printJobSpec.stockWeight !== 'INTRAN' && instantPrintJob.printJobSpec.stockWeight !== 'DUR' && instantPrintJob.printJobSpec.stockWeight !== 'TRU' && instantPrintJob.printJobSpec.stockWeight !== null"
                  >
                    gsm
                  </span>
                </p>
                <p v-else>-</p>
              </div>
              <!--</div>-->
              <!---->
              <!--<div class="component__forms-5">-->
              <div class="text__line-height-2 layout__padding-clear layout__width-100">
                <p class="component__subtitle component__columns-2">
                  Finishing
                </p>
                <div class="component__columns-2">
                  <p
                    class=""
                    v-if="instantPrintJob.printJobSpec.lamination === 'STANDARD' || instantPrintJob.printJobSpec.lamination === '' || instantPrintJob.printJobSpec.lamination === 'NONE' || instantPrintJob.printJobSpec.lamination === 'SILK'"
                  >
                    No Lamination
                  </p>
                  <p
                    class=""
                    v-else-if="instantPrintJob.printJobSpec.lamination === 'MATT LAM'"
                  >
                    Matt Lamination
                  </p>
                  <p
                    class=""
                    v-else-if="instantPrintJob.printJobSpec.lamination === 'GLOSS LAM'"
                  >
                    Gloss Lamination
                  </p>
                  <p v-else>-</p>
                </div>
              </div>
              <!--</div>-->
              <!--<div class="component__forms-5">-->
              <div class="text__line-height-2 layout__padding-clear layout__width-100">
                <p class="component__subtitle component__columns-2">
                  Quantity
                </p>
                <p class="component__columns-2">
                  {{ instantPrintJob.printJobSpec.quantity }}
                </p>
              </div>
              <div
                v-if="instantPrintJob.printJobSpec.envelopeAvailable"
                class="text__line-height-2 layout__padding-clear layout__width-100"
              >
                <p class="component__subtitle component__columns-2">
                  Envelope
                </p>
                <p class="component__columns-2">
                  {{ instantPrintJob.printJobSpec.envelope ? 'Yes' : 'No' }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="layout__padding__bottom-20px layout__display-flex">
      <el-button
        class="button-red button__base layout__width-150px layout__margin__right-10px ml-auto layout__display-block"
        @click="removeItem()"
      >
        Remove item
      </el-button>

      <el-button
        class="button-teal button__base layout__width-150px "
        @click="amendInstantPrint()"
      >
        Amend item
      </el-button>
    </div>
  </div>
</template>

<script>
import Router from '../../router';

export default {
  name: 'InstantPrintJob',

  props: {
    instantPrintJob: {
      type: Object,
      required: true,
    },
  },

  methods: {
    amendInstantPrint() {
      if (this.instantPrintJob.printJobSpec.fCode !== null) {
        Router.push({
          name: '/instant-print/print-selections',
          params: {
            printJob: this.instantPrintJob,
            preferences: this.instantPrintJob.printJobSpec,
          },
        });
      } else {
        Router.push({
          name: '/instant-print/artwork-preview',
          params: {
            printJob: this.instantPrintJob,
          },
        });
      }
    },

    removeItem() {
      this.$emit('removeInstantPrintItem', this.instantPrintJob);
    },
  },
};
</script>
